import AsyncStorage from '@react-native-async-storage/async-storage'
import * as AuthSession from 'expo-auth-session'
import * as SecureStore from 'expo-secure-store'
import Config from 'react-native-config'
import { oauthDiscovery, oauthRedirectUri, oauthScopes } from '../constants/oauth'
import { isWeb } from '../constants/platform'
import * as SecureStoreProvider from '../providers/expo-secure-store/expo-secure-store'
import { IOAuthTokensForStorage } from '../types/token'

export const OAuthService = {
    fetchTokens: async (code: string, codeVerifier: string) => {
        const accessTokenRequest = new AuthSession.AccessTokenRequest({
            clientId: Config.OAUTH_CONFIG_CLIENT_ID!,
            redirectUri: oauthRedirectUri,
            scopes: oauthScopes,
            code,
            extraParams: { code_verifier: codeVerifier },
        })

        const tokenResponse = await AuthSession.exchangeCodeAsync(accessTokenRequest, {
            tokenEndpoint: oauthDiscovery.tokenEndpoint,
        })

        return {
            accessToken: tokenResponse.accessToken,
            refreshToken: tokenResponse.refreshToken,
            expiresIn: tokenResponse.expiresIn,
            issuedAt: tokenResponse.issuedAt,
        } as IOAuthTokensForStorage
    },
    setTokensToStorage: async (tokens: IOAuthTokensForStorage) => {
        if (isWeb) {
            await AsyncStorage.setItem('oauthTokens', JSON.stringify(tokens))

            return
        }

        await SecureStore.setItemAsync('oauthTokens', JSON.stringify(tokens))
    },
    getTokensFromStorage: async () => {
        let json

        if (isWeb) {
            json = await AsyncStorage.getItem('oauthTokens')
        } else {
            json = await SecureStoreProvider.getItemAsync('oauthTokens')
        }

        if (!json) return

        try {
            const tokens = JSON.parse(json)

            if (!('expiresIn' in tokens && 'issuedAt' in tokens)) return

            return tokens as IOAuthTokensForStorage
        } catch (e) {
            if (isWeb) {
                await AsyncStorage.removeItem('oauthTokens')
            } else {
                await SecureStore.deleteItemAsync('oauthTokens')
            }
        }
    },
    removeTokensFromStorage: async () => {
        if (isWeb) {
            await AsyncStorage.removeItem('oauthTokens')

            return
        }

        await SecureStore.deleteItemAsync('oauthTokens')
    },
}
